import React, {useState, useEffect} from 'react';
import { AppWrap, MotionWrap } from '../../wrapper';
import './About.scss';
import { motion } from 'framer-motion'
import { images } from '../../constants'


const abouts = [
  {title: 'Computer Science', description: 'I have recently graduated from Newcastle University with a Bachelor of Computer Science', imgURL: images.uon},
  {title: 'Web Design', description: 'I enjoy spending extra time and effort perfecting my web based and java projects', imgURL: images.design},
  {title: 'Staying Updated', description: 'Always trying my best to stay up to date with the latest frameworks and coding practices', imgURL:images.improving},
  {title: 'Project Planning', description: 'I have no trouble planning out projects even when I am working with multiple team members',imgURL: images.planning},
]

const About = () => {
  return (
    <>
      <h2 className='about-text'>
      Actively Searching For Ways To <span>Improve</span><br />And Learn  <span>New Skills</span>
      </h2>



      <div className='app__profiles'>

      {abouts.map((about, index) => (

      <motion.div
      className="app__profile-item"
      key={about.title + index}
      >

      <img src={about.imgURL} alt={about.title} />
      <h2 className='name-text'>{about.title}</h2>
      <p className='para-text' style={{marginTop: 10}}>{about.description}</p>

      </motion.div>

      ))}


      </div>

    </>
  )
}


// export default AppWrap(
//   MotionWrap(About, 'app__about'), 
//   'about',
//   "app__whitebg"
//   );

export default AppWrap(About, 'about',
  "app__whitebg"
);